import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModelFilterPipe } from './ModelQuestionnaire/modelFilterPipe';
import { MediaModule } from '../media';
import { PipeModule } from '../pipes';
import { TagModule } from '../tag';
import { DateModule } from '../date';
import { MatchingQuestionComponent, DominoQuestionComponent } from './QuestionType';
import { PieComponent, BarComponent, ChartComponent } from './chart';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { QuestionnaireRoutingModule } from './questionnaire-routing.module';
import { QuestionnaireService } from './questionnaire.service';

import { CreateQuestionnaireComponent } from './CreateQuestionnaire/createQuestionnaire.component';
import { ModelCreationComponent } from './ModelQuestionnaire/modelCreation.component';
import { QuestionnaireComponent } from './Questionnaire/questionnaire.component';
import { ResultComponent } from './result/result.component';
import { ResultELComponent } from './result-el/result-el.component';
import { ApprenantComponent, QDateBadgePipe } from './apprenant/apprenant.component';
import { QuestionnaireUnavailableComponent } from './questionnaire-unavailable/questionnaire-unavailable.component';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PipeModule,
    MediaModule,
    TagModule,
    DateModule,
    CKEditorModule,
    QuestionnaireRoutingModule,
  ],
  declarations: [
    MatchingQuestionComponent,
    DominoQuestionComponent,
    QuestionnaireComponent,
    CreateQuestionnaireComponent,
    ModelCreationComponent,
    ModelFilterPipe,
    BarComponent,
    ChartComponent,
    PieComponent,
    ResultELComponent,
    ResultComponent,
    ApprenantComponent,
    QuestionnaireUnavailableComponent,
    QDateBadgePipe,
  ],
  exports: [
    QuestionnaireComponent,
    CreateQuestionnaireComponent,
    ModelCreationComponent,
    BarComponent,
    PieComponent,
    ChartComponent,
    ResultELComponent,
    ResultComponent,
    ApprenantComponent,
  ],
  providers: [QuestionnaireService],
})

export class QuestionnaireModule { }
